import { LinkAction } from "./LinkAction";
export class BreadcrumbAction extends LinkAction {
    constructor(breadcrumb, options = {}) {
        super({
            path: breadcrumb.buildPath(),
        }, {
            accessCheck: breadcrumb.accessCheck,
            ...options,
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnJlYWRjcnVtYkFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvYWN0aW9ucy9CcmVhZGNydW1iQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxVQUFVLEVBQTBCLE1BQU0sY0FBYyxDQUFDO0FBV2xFLE1BQU0sT0FBTyxnQkFBaUIsU0FBUSxVQUFVO0lBQzlDLFlBQ0UsVUFBc0IsRUFDdEIsVUFBbUMsRUFBRTtRQUVyQyxLQUFLLENBQ0g7WUFDRSxJQUFJLEVBQUUsVUFBVSxDQUFDLFNBQVMsRUFBRTtTQUM3QixFQUNEO1lBQ0UsV0FBVyxFQUFFLFVBQVUsQ0FBQyxXQUFXO1lBQ25DLEdBQUcsT0FBTztTQUNYLENBQ0YsQ0FBQztJQUNKLENBQUM7Q0FDRiJ9